import { ImageSelectorImage } from "@bluframe/mightychroma-mightytool-frontend-types"

const HASH_LENGTH = 6

/**
 * getImageIdentifier
 *
 * @description Get the image identifier
 * Creates a hash of the image id, contentId and originalUrl
 * @param {ImageSelectorImage} image - The image object
 * @returns {string} - The image identifier
 *
 */
const getImageIdentifier = (image: ImageSelectorImage): string => {
  const data = `${image.id}-${image.contentId}-${image.originalUrl}`

  let hash = 0
  for (let index = 0; index < data.length; index += 1) {
    // eslint-disable-next-line no-bitwise
    hash = (hash << 5) - hash + data.charCodeAt(index)
    // Convert to 32bit integer
    // eslint-disable-next-line no-bitwise
    hash |= 0
  }
  // eslint-disable-next-line no-magic-numbers
  return Math.abs(hash).toString(36).slice(0, HASH_LENGTH)
}

export default getImageIdentifier
